import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle, ChevronDown, Wifi, Wrench, CreditCard, Settings } from 'lucide-react';
import Footer from '../../components/footer';
import { useDarkMode } from '../../components/darkmode/DarkModeContext';

const faqData = [
  {
    category: 'Umum',
    icon: Wifi,
    questions: [
      { q: 'Apa itu Telnet Indonesia?', a: 'Telnet Indonesia (PT Telekomunikasi Internet Indonesia) adalah penyedia layanan internet (ISP) berbasis di Banda Aceh yang menyediakan layanan Internet Broadband, Dedicated, Metro-E, IPTV, CCTV, VPN, IT Support, dan berbagai solusi teknologi informasi lainnya untuk pelanggan rumahan maupun bisnis.' },
      { q: 'Area mana saja yang dilayani oleh Telnet Indonesia?', a: 'Saat ini Telnet Indonesia melayani area Banda Aceh, Aceh Besar, Sabang, dan beberapa kabupaten/kota di Provinsi Aceh. Kami terus memperluas coverage area. Anda dapat mengecek ketersediaan layanan di alamat Anda melalui halaman Coverage Check di website kami.' },
      { q: 'Berapa kecepatan internet yang tersedia?', a: 'Kami menyediakan berbagai pilihan kecepatan mulai dari 10 Mbps hingga 1 Gbps untuk paket broadband, dan hingga 10 Gbps untuk paket dedicated. Kecepatan aktual dapat bervariasi tergantung paket yang dipilih dan kondisi jaringan.' },
      { q: 'Apakah ada batasan kuota internet?', a: 'Tidak. Seluruh paket internet Telnet Indonesia adalah UNLIMITED tanpa batasan kuota (FUP). Anda dapat menggunakan internet sepuasnya tanpa khawatir kuota habis.' },
      { q: 'Bagaimana cara mendaftar layanan Telnet Indonesia?', a: 'Anda dapat mendaftar melalui: (1) Website kami di halaman Coverage Check, (2) WhatsApp ke 08777 888 2022, (3) Datang langsung ke kantor kami di Jl. Dr. Mr. Mohd. Hasan No. 33, Banda Aceh, atau (4) Menghubungi customer service kami.' },
    ],
  },
  {
    category: 'Teknis',
    icon: Wrench,
    questions: [
      { q: 'Berapa lama proses instalasi?', a: 'Proses instalasi biasanya memakan waktu 1-3 hari kerja setelah verifikasi data dan pembayaran biaya aktivasi (jika ada). Untuk lokasi yang memerlukan penarikan kabel jarak jauh, mungkin membutuhkan waktu lebih lama.' },
      { q: 'Apakah saya mendapatkan router/perangkat dari Telnet Indonesia?', a: 'Ya, kami menyediakan perangkat ONT (Optical Network Terminal) dan router WiFi yang sudah dikonfigurasi. Perangkat ini dipinjamkan selama masa berlangganan dan harus dikembalikan jika berhenti berlangganan.' },
      { q: 'Apa yang harus dilakukan jika internet lambat atau putus?', a: 'Langkah pertama: restart router dengan mematikan dan menyalakan kembali setelah 30 detik. Jika masalah berlanjut, hubungi customer service kami 24/7 melalui telepon atau WhatsApp. Tim teknisi kami akan merespons dalam waktu sesuai SLA.' },
      { q: 'Apakah Telnet Indonesia menyediakan IP Static?', a: 'Ya, kami menyediakan IP Static untuk paket tertentu. IP Static tersedia sebagai fitur bawaan di paket Dedicated dan Metro-E, serta dapat ditambahkan sebagai add-on di paket Broadband dengan biaya tambahan.' },
      { q: 'Bagaimana dengan keamanan jaringan?', a: 'Kami menggunakan teknologi keamanan terkini termasuk firewall, DDoS protection, dan monitoring jaringan 24/7 oleh tim NOC (Network Operations Center). Kami juga menyediakan layanan VPN dan Secure Firewall sebagai add-on untuk keamanan tambahan.' },
      { q: 'Apakah bisa menggunakan router sendiri?', a: 'Ya, Anda dapat menggunakan router sendiri. Namun, perangkat ONT dari Telnet Indonesia tetap harus terpasang sebagai perangkat utama. Tim teknisi kami akan membantu konfigurasi router Anda agar kompatibel dengan jaringan kami.' },
    ],
  },
  {
    category: 'Pembayaran',
    icon: CreditCard,
    questions: [
      { q: 'Apa saja metode pembayaran yang tersedia?', a: 'Kami menerima pembayaran melalui: Transfer bank (BCA, Mandiri, BNI, BRI, Bank Aceh), Virtual Account, E-wallet (GoPay, OVO, Dana), dan pembayaran langsung di kantor Telnet Indonesia.' },
      { q: 'Kapan tagihan diterbitkan dan jatuh tempo?', a: 'Tagihan diterbitkan setiap tanggal 1 setiap bulan. Jatuh tempo pembayaran adalah tanggal 20 setiap bulannya. Anda akan menerima notifikasi tagihan melalui email, SMS, dan WhatsApp.' },
      { q: 'Apa yang terjadi jika terlambat membayar?', a: 'Keterlambatan pembayaran dikenakan denda 2% per bulan. Setelah 7 hari terlambat, kecepatan internet akan diturunkan (throttle). Setelah 30 hari, layanan akan dinonaktifkan. Aktivasi ulang memerlukan pembayaran tunggakan plus biaya aktivasi ulang.' },
      { q: 'Apakah ada biaya instalasi?', a: 'Biaya instalasi tergantung pada paket yang dipilih dan lokasi. Beberapa paket menawarkan promo GRATIS biaya instalasi. Silakan hubungi tim sales kami untuk informasi terbaru mengenai promo yang berlaku.' },
      { q: 'Bisakah saya mendapatkan invoice/faktur pajak?', a: 'Ya, kami menerbitkan invoice bulanan yang dapat diakses melalui dashboard pelanggan. Untuk pelanggan bisnis/korporat, kami juga dapat menerbitkan faktur pajak resmi sesuai kebutuhan.' },
    ],
  },
  {
    category: 'Instalasi & Layanan',
    icon: Settings,
    questions: [
      { q: 'Apakah bisa upgrade atau downgrade paket?', a: 'Ya. Upgrade paket dapat dilakukan kapan saja dan efektif dalam 1-2 hari kerja. Downgrade hanya dapat dilakukan setelah masa kontrak minimum berakhir (biasanya 12 bulan).' },
      { q: 'Berapa kontrak minimum berlangganan?', a: 'Kontrak minimum untuk paket Broadband adalah 12 bulan, dan untuk paket Dedicated adalah 24 bulan. Setelah masa kontrak minimum, berlangganan berlanjut secara bulanan.' },
      { q: 'Bagaimana cara berhenti berlangganan?', a: 'Pengajuan berhenti berlangganan harus disampaikan minimal 30 hari sebelumnya. Jika masih dalam masa kontrak minimum, akan dikenakan biaya penalti. Perangkat milik Telnet Indonesia harus dikembalikan dalam kondisi baik.' },
      { q: 'Apakah tersedia layanan untuk bisnis/korporat?', a: 'Ya, kami menyediakan paket khusus untuk bisnis dan korporat termasuk Internet Dedicated, Metro-E, VPN site-to-site, Data Center hosting, dan solusi IT terintegrasi. Hubungi tim B2B kami untuk konsultasi dan penawaran khusus.' },
      { q: 'Apakah Telnet Indonesia menyediakan layanan CCTV?', a: 'Ya, kami menyediakan layanan IP Camera & CCTV lengkap termasuk instalasi, konfigurasi, dan monitoring. Layanan tersedia untuk rumah, kantor, pabrik, dan area publik dengan berbagai pilihan kamera indoor dan outdoor.' },
      { q: 'Bagaimana SLA (Service Level Agreement) Telnet Indonesia?', a: 'Kami menjamin uptime 99.5% per bulan dengan response time gangguan kritis < 4 jam. Jika SLA tidak terpenuhi, pelanggan berhak atas kompensasi berupa kredit tagihan sesuai tingkat gangguan. Detail lengkap SLA tersedia di halaman Ketentuan Layanan.' },
    ],
  },
];

const AccordionItem = ({ question, answer, isOpen, onToggle, isDarkMode }) => (
  <div className={`border-b last:border-0 ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}`}>
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between py-4 px-1 text-left hover:text-green-500 transition-colors"
    >
      <span className={`text-sm font-medium pr-4 ${isOpen ? 'text-green-500' : isDarkMode ? 'text-gray-200' : 'text-gray-800'}`}>
        {question}
      </span>
      <ChevronDown
        className={`w-5 h-5 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180 text-green-500' : isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}
      />
    </button>
    <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-4' : 'max-h-0'}`}>
      <p className={`text-sm leading-relaxed px-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{answer}</p>
    </div>
  </div>
);

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});
  const [activeCategory, setActiveCategory] = useState('Umum');
  const { isDarkMode } = useDarkMode();

  const toggleItem = (key) => {
    setOpenItems((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const activeFaq = faqData.find((f) => f.category === activeCategory);

  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      {/* Hero */}
      <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white pt-28 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <HelpCircle className="w-12 h-12 text-green-400 mx-auto mb-4" />
          <h1 className="text-3xl sm:text-4xl font-bold mb-4">Frequently Asked Questions</h1>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Temukan jawaban untuk pertanyaan yang sering diajukan tentang layanan Telnet Indonesia.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        {/* Category Tabs */}
        <div className="flex flex-wrap gap-2 mb-8 justify-center">
          {faqData.map((cat) => (
            <button
              key={cat.category}
              onClick={() => setActiveCategory(cat.category)}
              className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium transition-all ${
                activeCategory === cat.category
                  ? 'bg-green-600 text-white shadow-md'
                  : isDarkMode
                    ? 'bg-gray-800 text-gray-300 hover:bg-gray-700 border border-gray-700'
                    : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'
              }`}
            >
              <cat.icon className="w-4 h-4" />
              {cat.category}
            </button>
          ))}
        </div>

        {/* FAQ List */}
        <div className={`rounded-2xl shadow-sm border p-6 sm:p-8 ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'}`}>
          <div className="flex items-center gap-3 mb-6">
            {activeFaq && <activeFaq.icon className={`w-6 h-6 ${isDarkMode ? 'text-green-400' : 'text-green-600'}`} />}
            <h2 className={`text-xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{activeCategory}</h2>
          </div>

          <div>
            {activeFaq?.questions.map((item, idx) => (
              <AccordionItem
                key={`${activeCategory}-${idx}`}
                question={item.q}
                answer={item.a}
                isOpen={!!openItems[`${activeCategory}-${idx}`]}
                onToggle={() => toggleItem(`${activeCategory}-${idx}`)}
                isDarkMode={isDarkMode}
              />
            ))}
          </div>
        </div>

        {/* Still have questions */}
        <div className={`mt-12 text-center rounded-2xl shadow-sm border p-8 ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'}`}>
          <h3 className={`text-xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Masih punya pertanyaan?</h3>
          <p className={`mb-6 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Tim customer service kami siap membantu Anda 24/7.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="https://wa.me/628777882022"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-green-700 transition-colors"
            >
              Chat WhatsApp
            </a>
            <Link
              to="/kontak"
              className={`border-2 px-6 py-3 rounded-xl font-semibold transition-colors ${isDarkMode ? 'border-gray-600 text-gray-300 hover:bg-gray-700' : 'border-gray-300 text-gray-700 hover:bg-gray-50'}`}
            >
              Halaman Kontak
            </Link>
          </div>
        </div>

        {/* Related Links */}
        <div className="mt-8 text-center">
          <div className="flex justify-center gap-4 text-sm">
            <Link to="/kebijakan-privasi" className="text-green-600 hover:underline">Kebijakan Privasi</Link>
            <Link to="/ketentuan-layanan" className="text-green-600 hover:underline">Ketentuan Layanan</Link>
            <Link to="/alur-transaksi" className="text-green-600 hover:underline">Alur Transaksi</Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FAQ;
